const AppPatientProblems =()=> import('./patient-problems.vue');
import { guardRoute } from '../guardRouter';

import localeEn from '../../locales/en'
import localeAr from '../../locales/ar'

//pages

const PatientDiagnosis = () => import('./patient-diagnosis/patient-diagnosis.vue');
const PatientList = () => import('./patient-diagnosis/patient-list/patient-list.vue');
const DiagnosisSetting = () => import('./diagnosis-setting/diagnosis-setting.vue');
const DiagnosisSetup = () => import('./diagnosis-setting/diagnosis-setup/diagnosis-setup.vue');


export const translation = {
    en: {
        ...localeEn
    },
    ar: {
        ...localeAr
    }
}
const lang = localStorage.getItem('NG_TRANSLATE_LANG_KEY');

const patientProblemsRoutes = [
    {
        path: '/patient-problems',
        name: 'patient-problems',
        component: AppPatientProblems,
        meta: {
            title: translation[lang].Nav.PatientProblems.PatientProblems,
        },
        children: [
            //patient diagnosis
            {
                path: 'patient-diagnosis',
                name: 'patient-diagnosis',
                meta: { title: translation[lang].Nav.PatientProblems.PatientDiagnosis },
                component: PatientDiagnosis,
                children: [
                    {
                        path: 'patient-list',
                        name: 'patient-diagnosis/patient-list/patient-list.vue',
                        meta: {
                            title: translation[lang].Nav.PatientProblems.PatientList
                        },
                        component: PatientList,
                    },
                ]
            },
            {
                path: 'diagnosis-setting',
                name: 'diagnosis-setting',
                meta: {
                    title: "Diagnosis Setting",
                },
                component: DiagnosisSetting,
                children: [
                 
                    {
                        path: 'diagnosis-setup',
                        name: 'diagnosis-setting/diagnosis-setup',
                        meta: { title: translation[lang].Nav.PatientProblems.DiagnosisSetup },
                        component: DiagnosisSetup,

                    },
                ]
            },
          
        ],
        beforeEnter: guardRoute
    }
];

export default patientProblemsRoutes;
